<template>
	<form class="review" @submit.prevent="update">
		<PageHeader />
		<ManagingSection v-if="details">
			<ManagingBox title="노출">
				{{ details.isDisplay }}
			</ManagingBox>
			<ManagingBox title="리뷰 상태">
				<RadioList
					v-model="details.state"
					value-name="name"
					:radio-list="stateList"
				/>
			</ManagingBox>
			<ManagingBox title="블라인드 사유" :horizontal-mode="true">
				<Selector
					v-model="details.blindCause[0]"
					:option-list="blindCauseList"
					:disabled="details.state === 'N'"
					@input="blindCauseChange"
				/>
				<Selector
					v-model="details.blindCause[1]"
					:option-list="blindCauseList2"
					:disabled="details.state === 'N' || !details.blindCause[0]"
					class="review__blind-cause"
				/>
			</ManagingBox>
			<ManagingBox title="평가단여부">
				<RadioList
					v-model="details.isEvaluation"
					:radio-list="isEvaluationList"
				/>
			</ManagingBox>
			<ManagingBox title="픽플여부">
				<RadioList
					v-model="details.isPickple"
					:radio-list="isPickpleList"
				/>
			</ManagingBox>
			<ManagingBox title="작성자" :horizontal-mode="true">
				{{ details.writer.nickName }}
				<button
					type="button"
					class="btn blue review__writer-search"
					@click="openWriterSearchModal"
				>
					검색하기
				</button>
			</ManagingBox>
			<ManagingBox title="제품">
				<SearchProductBrand ref="idProduct" class="review__product" />
			</ManagingBox>
			<ManagingBox title="평점">
				<Selector v-model="details.rating" :option-list="ratingList" />
			</ManagingBox>
			<ManagingBox title="한줄평">
				{{ details.title }}
			</ManagingBox>
			<ManagingBox title="내용">
				<textarea v-model="details.reviewText" rows="10" />
			</ManagingBox>
			<ManagingBox title="작성일">
				{{ details.createDate }}
			</ManagingBox>
			<ManagingBox title="수정일">
				{{
					details.createDate === details.modifiedDate
						? ''
						: details.modifiedDate
				}}
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button type="submit" class="btn-main blue" v-text="'수정하기'" />
			<button
				type="button"
				class="btn-main"
				v-text="'다시작성'"
				@click="rewrite"
			/>
		</div>
		<ManagingSection>
			<ManagingBox title="메모">
				<MemoBox ref-type="reviewcomment" :ref-id="idReview" />
			</ManagingBox>
		</ManagingSection>
	</form>
</template>
<script>
	import compact from 'lodash/compact';
	import moment from 'moment';
	import { mapState } from 'vuex';
	import PageHeader from '@/components/PageHeader';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector';
	import SearchProductBrand from '@/components/SearchProductBrand';
	import DateBox from '@/components/DateBox';
	import MemoBox from '@/components/MemoBox';

	export default {
		name: 'ReviewDetail',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			RadioList,
			Selector,
			SearchProductBrand,
			DateBox,
			MemoBox,
		},
		data() {
			return {
				idReview: Number(this.$route.params.idReview),
				originDetails: null,
				details: null,
				isEvaluationList: [
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				isPickpleList: [
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				ratingList: [
					{ value: null, name: '평점' },
					...[...new Array(5).keys()].map(idx => ({
						value: idx + 1,
						name: idx + 1,
					})),
				],
			};
		},
		computed: {
			...mapState({
				stateList: state => state.filter.reviewCommentStateList,
				causeList: state => state.notice.causeList,
			}),
			blindCauseList() {
				return [
					{ value: null, name: '사유를 선택하세요' },
					...(this.causeList || []),
				];
			},
			blindCauseList2() {
				const cause = this.details.blindCause[0];
				return cause
					? this.blindCauseList.filter(({ value }) => value !== cause)
					: this.blindCauseList;
			},
		},
		created() {
			this.getDetails();
		},
		methods: {
			blindCauseChange() {
				this.details.blindCause[1] = null;
			},
			openWriterSearchModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'WriterSearch',
					params: {
						selectWriter: writer => {
							this.details.writer = writer;
						},
					},
				});
			},
			setFilter(data) {
				this.details = {
					...data,
					isDisplay: data.isDisplay ? '전시' : '비전시',
					blindCause: [null, null],
				};
				if (data.blindCause) {
					data.blindCause.forEach((item, idx) => {
						this.details.blindCause[idx] = item.id;
					});
				}
				this.$nextTick(() => {
					this.$refs.idProduct.selecting(
						data.product.idProduct,
						data.product.productTitle
					);
				});
			},
			async getDetails() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/review/${this.idReview}`
					);
					if (!this.causeList) {
						await this.$store.dispatch('notice/init');
					}
					this.originDetails = {
						...data,
						createDate: moment(
							data.createDate,
							'YYYYMMDDHHmmss'
						).format('YYYY-MM-DD HH:mm:ss'),
						modifiedDate: moment(
							data.modifiedDate,
							'YYYYMMDDHHmmss'
						).format('YYYY-MM-DD HH:mm:ss'),
					};
					this.setFilter(this.originDetails);
				} catch (err) {
					console.error(err);
				}
			},
			validate() {
				const cause = this.details.blindCause;
				if (
					['B', 'C'].includes(this.details.state) &&
					(!cause || !compact(cause).length)
				) {
					alert('블라인드 사유를 선택해 주세요.');
					return false;
				} else if (!this.$refs.idProduct.selectedObj) {
					alert('제품을 선택하세요.');
					return false;
				} else if (!this.details.rating) {
					alert('평점을 선택하세요.');
					return false;
				} else if (!this.details.reviewText) {
					alert('내용을 선택하세요.');
					return false;
				} else if (!this.details.createDate) {
					alert('작성일을 입력하세요.');
					return false;
				}
				return true;
			},
			async update() {
				try {
					if (!this.validate()) {
						return;
					}
					if (!confirm('정말 수정하시겠습니까?')) {
						return;
					}
					const params = {
						idReviewComment: this.idReview,
						...this.details,
						createDate: moment(
							this.details.createDate,
							'YYYY-MM-DD HH:mm'
						).format('YYYYMMDDHHmmss'),
						writer: { idRegister: this.details.writer.idRegister },
						product: {
							idProduct:
								this.$refs.idProduct.selectedObj.idProduct,
						},
						isPickple: this.details.isPickple,
					};
					if (['B', 'C'].includes(this.details.state)) {
						params.causeIds = compact(this.details.blindCause);
					}
					delete params.isDisplay;
					delete params.blindCause;
					delete params.title;
					await this.$axiosAdmin2.put('/v3/api/review', params);
					this.$router.go(-1);
				} catch (err) {
					console.error(err);
				}
			},
			rewrite() {
				this.setFilter(this.originDetails);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.review__blind-cause {
		margin-left: 12px;
	}

	.review__writer-search {
		margin-left: 12px;
	}

	.review__product {
		width: 100%;
	}
</style>
